module.exports = __webpack_public_path__ + "static/top-banner-mobile-21b2a7d73fed6a7a854e71d32fbe8c64.png";